import React, { forwardRef, useMemo } from 'react';
import QRCode from 'qrcode.react';
import ZenLogo from '../../assets/images/logo-100.png';

interface ZenQRCodeProps {
    value: string;
    size?: number;
    fgColor?: string;
    id?: string;
}

const ZenQRCode = forwardRef<HTMLDivElement, ZenQRCodeProps>(({ value, size = 512, fgColor = '#394252' }, ref) => {
    const isIOS = useMemo(
        () => navigator.platform === 'iPad' || navigator.platform === 'iPhone' || navigator.platform === 'iPod',
        [],
    );
    return (
        <div ref={ref}>
            <QRCode
                id={`qrCodeEl`}
                size={size}
                value={value}
                fgColor={fgColor}
                style={{ width: '100%', height: '100%' }}
                includeMargin
                renderAs={isIOS ? 'svg' : 'canvas'}
                imageSettings={{ src: ZenLogo, width: size * 0.1171875, height: size * 0.1171875, excavate: true }}
            />
        </div>
    );
});
ZenQRCode.displayName = 'ZenQRCode';

export default ZenQRCode;
